import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="mx-auto flex min-h-[60vh] max-w-[1440px] flex-col items-center justify-center px-4 py-20 text-center md:px-8">
      <p className="font-heading text-6xl font-black text-primary-200 md:text-8xl">404</p>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个页面还没有整理好
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址暂时找不到对应内容：<span className="text-foreground-800">{location.pathname}</span>
        。回到目录里，从合集或榜单重新出发吧。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/topics"
          className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          浏览专题合集
        </Link>
      </div>
    </section>
  );
}